// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H12.8762C12.0139 21.897 11.5 20.5085 11.5 19C11.5 15.4101 14.4101 12.5 18 12.5C19.0821 12.5 20.1025 12.7644 21 13.2322V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.05 14.0879L23.9083 19.0021L19.05 23.9163L17.6277 22.5102L20.1073 20.0021L12.998 20.0021V18.0021L20.1073 18.0021L17.6277 15.494L19.05 14.0879Z"}}]};

const FileExportFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-export-filled',
    ref,
    icon: element,
  },
));

FileExportFilledIcon.displayName = 'FileExportFilledIcon';

export default FileExportFilledIcon;
